import React, { createContext, useContext, useEffect, useCallback } from 'react';

const ThemeContext = createContext(null);

export const ThemeProvider = ({ children }) => {
  useEffect(() => {
    try {
      localStorage.removeItem('mt_theme');
      localStorage.setItem('mt_theme', 'light');
    } catch {
      /* ignore */
    }

    const root = document.documentElement;
    root.setAttribute('data-theme', 'light');
    root.classList.remove('dark-theme');
    root.classList.add('light-theme');

    let meta = document.querySelector('meta[name="theme-color"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'theme-color';
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', '#00A86B');
  }, []);

  const toggleTheme = useCallback(() => {}, []);
  const setTheme = useCallback(() => {}, []);

  return (
    <ThemeContext.Provider value={{ theme: 'light', isDark: false, toggleTheme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    return { theme: 'light', isDark: false, toggleTheme: () => {}, setTheme: () => {} };
  }
  return context;
};
